module.exports = __webpack_public_path__ + "static/software-project-cb93027c38279a71bbeca0fa494f58bc.jpg";